import { createSelector } from 'reselect'

import type { Venue } from '@/types/app-types'

import type { VenuesStateType } from './types'

export const venuesSelector = createSelector(
    (state: VenuesStateType) => state.data?.items || [],
    (venues: Venue[] | undefined): Venue[] => venues || [],
)
